import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthControllerService} from '../../../../app/services/auth-controller/auth-controller.service';

@Component({
  selector: 'app-wrapper',
  templateUrl: './wrapper.component.html',
})
export class WrapperComponent implements OnInit{
	@Input() wrapperCssClass: string;
    isUserDefined = false;

    constructor(private activatedRoute: ActivatedRoute,
                private authService: AuthControllerService,
                private router: Router) {
    }

    ngOnInit() {
		this.recompute = this.recompute.bind(this);
        this.authService.subscribeForTokenChange(this.recompute);
        this.recompute();
	}

	ngOnDestroy(): void {
		this.authService.unsubscribe(this.recompute);
	}


    private recompute() {
        if (this.authService.isLogged) {
            this.isUserDefined = true;
        }
    }

}
